/**
 * FS-823: the raw charts' title, in the object form Plotly 3 reads (a plain
 * string is silently dropped and the chart renders untitled).
 *
 * Plotly centres a title in the top margin, which is the row its toolbar
 * occupies at the top right (2-26 px, shown on hover); on a narrow chart, such
 * as a side-by-side comparison, a long device name ran under it. Pinned 32 px
 * down from the top it clears the toolbar at any width, and RAW_CHART_TOP_MARGIN
 * leaves room below it for the "not yet analysed" label that sits on the plot's
 * top edge.
 */
export const rawChartTitle = (text: string) => ({
  text,
  yref: 'container' as const,
  y: 1,
  yanchor: 'top' as const,
  pad: { t: 32 },
});

/** Title (32 + ~21 px), a gap, then the 14 px band label above the plot. */
export const RAW_CHART_TOP_MARGIN = 80;
